<script>
  import ByPersonTrendChart from './ByPersonTrendChart.vue';

  export default {
    name: 'PatientsPurchasedTrends',
    extends: ByPersonTrendChart,
    data() {
      return {
        chartId: 'patientPurchasedTrends',
        propertyName: 'number_patients_purchased',
        propertyNamePerson: 'num_ha_fittings',
        label: '# Patients Purchased',
        curYearColor: '#824A9E',
        prevYearColor: '#39C2C9',
        labelFormat: ',.0f',
      };
    },
  };
</script>
